import React from "react";
import useStore from "../../../../context/useStore";
import useManagers from "../../../../hooks/useManagers/useManagers";
import useLeadAutoList from "../useLeadAutoList";
import useLeadAutoFilters from "./useLeadAutoFilters";
import { buildFilterTokens } from "./leadAutoFilterTokens";

// Ligne de résumé : chaque filtre actif devient un jeton retirable ; à droite
// le nombre de résultats et « Tout effacer ». Rien n'est rendu sans filtre.
const LeadAutoActiveFiltersSummary = () => {
  const [state] = useStore();
  const { managers } = useManagers();
  const { leadAutoList, nbLead } = useLeadAutoList();
  const { leadAutoFilters, actions } = useLeadAutoFilters();
  const { LEAD_STATUS, LEAD_TASKS } = state.constants.items;
  const userId = state.auth?.user?.id;

  const tokens = buildFilterTokens(leadAutoFilters, {
    userId,
    managers,
    LEAD_STATUS,
    leadTasks: LEAD_TASKS,
  });

  if (!tokens.length) return null;

  const isListInit = leadAutoList !== null;

  return (
    <div className="lf-summary">
      <span className="lf-lbl">FILTRES</span>
      {tokens.map((t) => (
        <span key={t.key} className="lf-token">
          <span>{t.label}</span>
          <button
            type="button"
            className="lf-x"
            onClick={() => actions.removeFilterToken(t.clear)}
            aria-label={`Retirer le filtre ${t.label}`}
          >
            <i className="fa fa-times" />
          </button>
        </span>
      ))}
      <span className="lf-right">
        {isListInit && (
          <span className="lf-count-res" aria-live="polite">
            {nbLead.toLocaleString("fr-FR")} résultat{nbLead > 1 ? "s" : ""}
          </span>
        )}
        <button
          type="button"
          className="lf-clear"
          onClick={actions.clearAllFilters}
        >
          Tout effacer
        </button>
      </span>
    </div>
  );
};

export default LeadAutoActiveFiltersSummary;
